/* Mappe: Werke werden umgeschaltet (hinzufügen / entfernen), wie onToggleFolio in der Vorlage.
   Beschriftungen kommen aus dem Liquid-Markup, damit die Texte im Theme bleiben. */
(function () {
  var routes = (window.waTheme && window.waTheme.routes) || {};

  function updateCounters(count) {
    document.querySelectorAll('[data-wa-mappe-count]').forEach(function (el) {
      el.textContent = count > 0 ? ' (' + count + ')' : '';
    });
    tick();
  }

  /* Der Eintrag in der Kopfzeile tickt einmal an, sobald sich die Mappe ändert
     (folioPulse in der Vorlage). */
  function tick() {
    document.querySelectorAll('[data-wa-mappe-link]').forEach(function (el) {
      el.removeAttribute('data-wa-tick');
      // Reflow erzwingen, sonst startet die Animation beim zweiten Mal nicht neu.
      void el.offsetWidth;
      el.setAttribute('data-wa-tick', '1');
    });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Mappe: Anfrage fehlgeschlagen');
      return response.json();
    });
  }

  function readCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function setState(button, inMappe) {
    button.dataset.waIn = inMappe ? 'true' : 'false';
    button.textContent = inMappe ? button.dataset.waLabelIn : button.dataset.waLabelOut;
  }

  function toggle(button) {
    if (button.hasAttribute('disabled') || button.dataset.waBusy === '1') return;

    var variantId = button.dataset.waVariant;
    var inMappe = button.dataset.waIn === 'true';
    button.dataset.waBusy = '1';

    // Die Werkangabe reist als Positionseigenschaft mit. Shopify zeigt sie damit
    // in der Mappe, in der Kasse und auf der Bestellung unter dem Titel. Fehlen die
    // Metafelder, steht am Button keine Angabe und es wird nichts mitgeschickt.
    var item = { id: Number(variantId), quantity: 1 };
    var note = button.dataset.waNote;
    var noteLabel = button.dataset.waNoteLabel;

    if (note && noteLabel) {
      item.properties = {};
      item.properties[noteLabel] = note;
    }

    var request = inMappe
      ? postJson(routes.cartChange, { id: variantId, quantity: 0 })
      : postJson(routes.cartAdd, { items: [item] });

    request
      .then(function () {
        return readCart();
      })
      .then(function (cart) {
        setState(button, !inMappe);
        updateCounters(cart.item_count);
      })
      .catch(function () {
        // Bei einem Fehler den Zustand serverseitig neu bestimmen.
        window.location.reload();
      })
      .finally(function () {
        delete button.dataset.waBusy;
      });
  }

  function bind(root) {
    root.querySelectorAll('[data-wa-mappe-toggle]').forEach(function (button) {
      if (button.dataset.waBound === '1') return;
      button.dataset.waBound = '1';
      button.addEventListener('click', function () {
        toggle(button);
      });
    });
  }

  bind(document);

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target || document);
  });
})();
